import templateHtml from './public-app-shell.html';

const component = {};
component.template = templateHtml;
component.controllerAs = 'vm';
component.controller = function PublicAppShellComponentController() {
};

component.controller.$inject = [];

export const PublicAppShellComponent = component;
